import apiClient from "./api.client.service";

interface VerifyPaymentDto {
  razorpay_subscription_id: string;
  razorpay_payment_id: string;
  razorpay_signature: string;
}

class PaymentService {
  private APIBaseUrl: string;

  constructor() {
    this.APIBaseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
    // this.APIBaseUrl = process.env.REACT_APP_PAYMENT_VERIFY ?? "";
  }

  async verifyPayment(data: VerifyPaymentDto) {
    try {
      const response = await apiClient.post(
        `${this.APIBaseUrl}/admin/subscription/verify-payment`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("🚀 ~ PaymentService ~ verifyPayment ~ error:", error);
    }
  }
}

const paymentService = new PaymentService();
export default paymentService;
